module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "buttonStyle": this.existing ? 'success' : 'primary',
      "heading": _vm.heading,
      "centerButton": true,
      "showText": _vm.showText,
      "buttonText": _vm.button,
      "buttonIcon": "fa fa-plus",
      "disableButton": !_vm.isManager('admin|finance|management') || _vm.readOnly
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('el-tabs', [(!_vm.adding) ? _c('el-tab-pane', {
    attrs: {
      "label": "Insurer"
    }
  }, [_c('el-form', {
    ref: "insurerForm",
    model: {
      value: (_vm.insurer),
      callback: function($$v) {
        _vm.insurer = $$v
      },
      expression: "insurer"
    }
  }, [_c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": _vm.adding ? 20 : 18
    }
  }, [_c('select-insurer', {
    attrs: {
      "label": "",
      "callback": _vm.orgChange
    },
    model: {
      value: (_vm.insurer.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "organisation_id", $$v)
      },
      expression: "insurer.organisation_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center",
      "span": _vm.adding ? 0 : 3
    }
  }, [(!_vm.adding) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "fa fa-edit",
      "disabled": _vm.editing
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("Update")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center",
      "span": _vm.adding ? 0 : 3
    }
  }, [(!_vm.adding) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "fa fa-plus",
      "disabled": !_vm.searched
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("Add New...")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.adding) ? _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "placeholder": "Name"
    },
    model: {
      value: (_vm.organisation.name),
      callback: function($$v) {
        _vm.$set(_vm.organisation, "name", $$v)
      },
      expression: "organisation.name"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Address",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.organisation.address),
      callback: function($$v) {
        _vm.$set(_vm.organisation, "address", $$v)
      },
      expression: "organisation.address"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 2)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Post Code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Post Code",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.organisation.postCode),
      callback: function($$v) {
        _vm.$set(_vm.organisation, "postCode", $$v)
      },
      expression: "organisation.postCode"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-barcode"
  })])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 3
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "phone",
      "placeholder": "Phone",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.organisation.phone),
      callback: function($$v) {
        _vm.$set(_vm.organisation, "phone", $$v)
      },
      expression: "organisation.phone"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-earphone"
  })])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "E-Mail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": "E-Mail",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.organisation.email),
      callback: function($$v) {
        _vm.$set(_vm.organisation, "email", $$v)
      },
      expression: "organisation.email"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 2)], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Bank Details")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Beneficiary Name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Beneifciary Name",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.insurer.beneficaryName),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "beneficaryName", $$v)
      },
      expression: "insurer.beneficaryName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Bank Name",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.insurer.bankName),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "bankName", $$v)
      },
      expression: "insurer.bankName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Account No.",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.insurer.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "bankAccount", $$v)
      },
      expression: "insurer.bankAccount"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Agreement"
    }
  }, [_c('el-form', {
    ref: "landAgreementFrom",
    attrs: {
      "align": "left",
      "label-position": "top"
    },
    model: {
      value: (_vm.insurer),
      callback: function($$v) {
        _vm.insurer = $$v
      },
      expression: "insurer"
    }
  }, [_c('h3', [_vm._v("Policy Details")]), _vm._v(" "), (_vm.adding) ? _c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_vm._v("\n          Insurer\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('select-insurer', {
    attrs: {
      "label": "",
      "callback": _vm.orgChange
    },
    model: {
      value: (_vm.insurer.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "organisation_id", $$v)
      },
      expression: "insurer.organisation_id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_vm._v("\n          Policy Type\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('select-insurance-policy-type', {
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.insurer.policyType),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "policyType", $$v)
      },
      expression: "insurer.policyType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('text-input', {
    attrs: {
      "label": "",
      "placeholder": "Policy No."
    },
    model: {
      value: (_vm.insurer.policyNo),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "policyNo", $$v)
      },
      expression: "insurer.policyNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_vm._v("\n          Premium\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('number-input', {
    model: {
      value: (_vm.insurer.premium),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "premium", $$v)
      },
      expression: "insurer.premium"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 5
    }
  }, [_c('select-frequency', {
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.insurer.frequency),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "frequency", $$v)
      },
      expression: "insurer.frequency"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "align": "left",
      "span": 4
    }
  }, [_c('el-form-item', [_vm._v("\n          Insured Amount\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-input-number', {
    model: {
      value: (_vm.insurer.insuredAmount),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "insuredAmount", $$v)
      },
      expression: "insurer.insuredAmount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_vm._v("\n          Agreement Start\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('date-input', {
    model: {
      value: (_vm.insurer.coverageStart),
      callback: function($$v) {
        _vm.$set(_vm.insurer, "coverageStart", $$v)
      },
      expression: "insurer.coverageStart"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-form-item', [_vm._v("\n          Expiry\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_c('el-form-item', [_c('b', [_vm._v(_vm._s(_vm.expiryDate))])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_vm._v("\n          Tenor (months)\n        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('el-form-item', [_c('el-slider', {
    attrs: {
      "min": 6,
      "max": 240,
      "step": 6,
      "show-stops": "",
      "show-input": ""
    },
    model: {
      value: (_vm.tenor),
      callback: function($$v) {
        _vm.tenor = $$v
      },
      expression: "tenor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center",
      "span": 2
    }
  }, [_c('el-form-item', [_c('i', [_vm._v(_vm._s(_vm.years) + " yrs.")])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec8c308e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/InsuranceAction.vue
// module id = 1650
// module chunks = 0